import { get, set, reduce, filter } from "lodash"
import { createSelector } from "reselect"

const EMPTY_ARRAY = []

const getRawUploadingItems = state => get(state, "modules.resources.uploadingItems", EMPTY_ARRAY)
const getRawPermissions = (_, props) => get(props, "resourcesPermissions.resources")
export const getPermissions = createSelector([getRawPermissions], permissions => filter(permissions))
export const getFavoriteResources = state => get(state, "global.data.userFavoriteResources.data.0.value", EMPTY_ARRAY)

export const getFavoritesAsObject = createSelector(
  [getFavoriteResources],
  (favoriteResources) => reduce(favoriteResources, (favorites, { resourceId }) => set(favorites, resourceId, true), {}),
)

export const getUploadingItems = createSelector(
  [getRawUploadingItems],
  (items) => reduce(items, (uploading, resourceId) => set(uploading, resourceId, true), {}),
)
